import {
  ACTIVE_STATE, ACTIVE_STATE_ACTIVE, ACTIVE_STATE_INACTIVE, LIST_FILTER_ALL,
} from 'src/util/constants';

/**
 * Builds the filter bar button configuration for the All | Active | Inactive filter.
 * @param {object} intl - The intl object returned by useIntl().
 * @param {string} activeState - The currently selected filter state.
 * @returns {Array<object>} An array of filter bar button group objects.
 */
const displayFilterBarButtons = (intl, activeState) => {
  const allLabel = intl.formatMessage({ id: 'dashboard.filter_bar_buttons.all.label', defaultMessage: 'All' });
  const activeLabel = intl.formatMessage({ id: 'dashboard.filter_bar_buttons.active.label', defaultMessage: 'Active' });
  const inactiveLabel = intl.formatMessage({ id: 'dashboard.filter_bar_buttons.inactive.label', defaultMessage: 'Inactive' });

  return [
    {
      group: LIST_FILTER_ALL,
      items: [
        {
          value: LIST_FILTER_ALL,
          label: allLabel,
          active: activeState === LIST_FILTER_ALL,
        },
      ],
    },
    {
      group: ACTIVE_STATE,
      items: [
        {
          value: ACTIVE_STATE_ACTIVE,
          label: activeLabel,
          active: activeState === ACTIVE_STATE_ACTIVE,
        },
        {
          value: ACTIVE_STATE_INACTIVE,
          label: inactiveLabel,
          active: activeState === ACTIVE_STATE_INACTIVE,
        },
      ],
    },
  ];
};

export default displayFilterBarButtons;
